// extracted by mini-css-extract-plugin
export default {"list":"DiscussList_list__hu8j6"};